import { exportqueueConstants } from '../constants'

const initialState = {
  list: null,
  loading: false,
  error: null,
  silentLoading: false
}

export default function exportqueue (state = initialState, action) {
  switch (action.type) {
    case exportqueueConstants.DO_EXPORT:
      return { ...state, loading: true }
    case exportqueueConstants.DO_EXPORT_SUCCESS:
      return { ...state, loading: false }
    case exportqueueConstants.DO_EXPORT_FAILURE:
      return { ...state, loading: false }
    case exportqueueConstants.CHECK_EXPORT:
      return { ...state, silentLoading: true }
    case exportqueueConstants.CHECK_EXPORT_SUCCESS:
      return { ...state, silentLoading: false, list: action.payload }
    case exportqueueConstants.CHECK_EXPORT_FAILURE:
      return { ...state, error: action.payload, silentLoading: false }
    default:
      return state
  }
}
